/* eslint import/no-webpack-loader-syntax: off */

import 'babel-polyfill';

import 'file-loader?name=[name].[ext]!features/OneSignal/OneSignalSDKUpdaterWorker.js'; // eslint-disable-line import/extensions
import 'file-loader?name=[name].[ext]!features/OneSignal/OneSignalSDKWorker.js'; // eslint-disable-line import/extensions

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {createBrowserHistory} from 'history';
import 'sanitize.css/sanitize.css';
import 'moment/locale/ru';
import register from './serviceWorker'
import App from 'containers/App';
import LanguageProvider from 'containers/LanguageProvider';
import {initializeScreenProperties} from 'domain/Screen/actions';
import {getScreenProperties} from 'utils/screenUtils';
import configureStore from './configureStore';
import {translationMessages} from './i18n';
import config from 'config';
import {hubConnection} from 'signalr-no-jquery';
import {sendUserId, updateNeed} from 'utils/signalrUtils';
import {getValueFromLocalStorage} from 'utils/localStorage';
import {UPDATE_BY_SIGNALR} from 'global-constants';
import './global-styles';
import './global-api';
import './main.css';

export const connection = hubConnection(config.pushServerUrl);
export const hubProxy = connection.createHubProxy('dBEventsHub');

hubProxy.on('appendnewmessage', function (user, message) {
    if (getValueFromLocalStorage(UPDATE_BY_SIGNALR)) {
        const entityName = updateNeed(message);
        if (entityName && entityName.length > 0) {
            const event = new CustomEvent('signalRMessage', {detail: {entityName}});
            window.dispatchEvent(event);
        }
    }
});

hubProxy.on('confirmPersonalData', function () {
    const event = new CustomEvent('signalRMessage', {detail: {entityName: 'requests'}});
    window.dispatchEvent(event);
});

hubProxy.on('showArrivedDialog', function (requestId) {
    const event = new CustomEvent('signalRMessage', {detail: {requestId}});
    window.dispatchEvent(event);
});


connection.start({})
    .done(function () {
        console.log('Now connected, connection ID=' + connection.id);
        sendUserId()
    })
    .fail(function () {
        console.log('Could not connect');
    });

const initialState = {};
const history = createBrowserHistory();
const store = configureStore(initialState, history);

store.dispatch(initializeScreenProperties(getScreenProperties()));

const MOUNT_NODE = document.getElementById('app');

const render = (messages) => {
    ReactDOM.render(
        <Provider store={store}>
            <LanguageProvider messages={messages}>
                <App history={history}/>
            </LanguageProvider>
        </Provider>,
        MOUNT_NODE
    );
};

if (module.hot) {
    module.hot.accept(['./i18n', 'containers/App'], () => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render(translationMessages);
    });
}

if (!window.Intl) {
    (new Promise((resolve) => {
        resolve(import('intl'));
    }))
        .then(() => Promise.all([
            import('intl/locale-data/jsonp/en.js'),
            import('intl/locale-data/jsonp/ru.js'),
        ]))
        .then(() => render(translationMessages))
        .catch((err) => {
            throw err;
        });
} else {
    render(translationMessages);
}

register();